import { render, staticRenderFns } from "./AddingTickets.vue?vue&type=template&id=6d01fcb4&"
import script from "./AddingTickets.vue?vue&type=script&lang=js&"
export * from "./AddingTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports